import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const LostReasonForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    const apiObject = 'lost_reason'

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'deal.lost_reason.general.name_label',
            type: 'text',
            placeholder: 'deal.lost_reason.general.name_placeholder',
        },
    ];

    return (
        <FormModal 
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
        />
    );
};

export default LostReasonForm;